// extracted by mini-css-extract-plugin
export var component = "NoticeModule-module--component--a1KNI";
export var content = "NoticeModule-module--content--8aTjs";
export var hasIcon = "NoticeModule-module--hasIcon--Zm7BR";
export var icon = "NoticeModule-module--icon--iLvFq";
export var title = "NoticeModule-module--title--kHZbH";